// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  enableLegacyAnalyticsWrappers: false,
  shoppingBaseUrl: 'https://preprod.scandid.in',
  txBaseUrl: 'https://omega-api.travelvip.ai',
  checkoutUrl: 'https://dev-checkout.travelx.ai/checkout',
  mixpanelToken: '84b17366c20b0c5ff7593d1814c3c39e',
  signozUrl: 'https://ingest.us2.signoz.cloud',
  signozIngestionKey: '',
  key: 'palsgcvgscvvs',
  pid: 'smt',
  stripePublishableKeys: {
    smt: 'pk_test_51InXIZEWyGwVPuvkaXP1rUvxAUXM64i8oTafJuPJYmQUy2VWhWmqiL5bhH3Afp9rMuvSFR9MVG8jDpra67kV7Ofy006h8CB6kK',
    ent: 'pk_test_7AK7DPTjJU80Gm64whphP8s1',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyA46VKGlIOW5KCJUdmBbHZ5horjVAz9om4',
    authDomain: 'travelx-v2-5abd8.firebaseapp.com',
    projectId: 'travelx-v2-5abd8',
    storageBucket: 'travelx-v2-5abd8.appspot.com',
    messagingSenderId: '1083838168675',
    appId: '1:1083838168675:web:e8a55cbceebd6c6df7c256',
    measurementId: 'G-5FQ2K898N0',
  },
  sentryBaseUrl: 'https://79fb2fa16e225a80e9405c21611f57c5@sentry.travelx.ai/3',
  sentryEnv: 'development',
  sentryErrorEnable: true,
  measurementIdGA: 'G-3QKC8KF9N3',
  configCat: 'configcat-sdk-1/ZpDcCL2dd0SMHgi4UcW0Wg/HK7IyryfHk-nK138WUJVdA',
  googlePlacesApiKey: 'AIzaSyCOPOFxcn_TkTfgwTwqHVZ-yjEcVXt8mgA',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

